import { CANONICAL_ORIGIN, pageMeta, type PageMeta } from '../models/site';
import { lifeShopIdFromPath, lifeShopPath } from '../models/life';

export type PageViewModel = PageMeta & {
  canonicalUrl: string;
  robots: string;
};

export function normalizePath(input: string): string {
  const pathname = input.split('?')[0]?.split('#')[0] || '/';
  if (pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export function presentPage(inputPath: string): PageViewModel | null {
  const path = normalizePath(inputPath);
  const lifeShopId = lifeShopIdFromPath(path);
  const shopPath = lifeShopId ? lifeShopPath(lifeShopId) : null;
  const meta = pageMeta[path] ?? (shopPath ? {
    path: shopPath,
    title: '都蘭店家介紹 | 小星在地筆記 — 都蘭小星民宿',
    description: '查看都蘭小星民宿整理的都蘭店家與在地生活筆記。',
    noindex: true,
  } : undefined);
  if (!meta) return null;
  const canonicalPath = meta.canonicalPath ?? path;
  return {
    ...meta,
    canonicalUrl: `${CANONICAL_ORIGIN}${canonicalPath === '/' ? '/' : canonicalPath}`,
    robots: meta.noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large',
  };
}
